module.exports = __webpack_public_path__ + "static/media/address_image.39469ca1.svg";